export default __webpack_public_path__ + "static/media/help_page_banner.82b3e8fe.png";